import React, { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from 'react-router-dom';


const ARTabs = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { moduleId } = useParams();
    const Child = props.ChildComponent;
    const { tabName } = props;
    const locationData = location.state || {};
    const [moduleName, setModuleName] = useState("");
    const [parentId, setParentId] = useState(null);


    const handleTabSelect = (selectedTab) => {
        if (selectedTab === "back") {
            navigate(`/ar/list`)
        } else {
            navigate(`/dashboard/ar/${selectedTab}/${moduleId}`);
        }
    };

    useEffect(() => {
        setModuleName(locationData?.name || "");
        setParentId(locationData?.parentId || null);
    }, [locationData])

    return (
        <>
            <div className='filterhere'>

                <Nav variant="tabs" activeKey={tabName} onSelect={handleTabSelect}>
                    <Nav.Item>
                        <Nav.Link eventKey="back"><span><i className="bi-chevron-left"></i> Back </span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="details"><span> Details </span></Nav.Link>
                    </Nav.Item>
                </Nav>

            </div>
            <div className='allcompages pt-0'>
                <Child {...props}></Child>
            </div>
        </>
    )
}
export default ARTabs